import { formatToTwoDecimal } from "../../../../../utils/numberFormatter";
import { exportGroupedExcel } from "../../../../../utils/export/groupedExcel";
import { getCustomerName } from "./InvoicePdf";

const ITEM_COLUMNS = [
  "Product Code",
  "Product Name",
  "Unit Price",
  "Qty",
  "Moisture",
  "Net Qty",
  "Discount",
  "Subtotal",
];

function getCurrencySymbol(currency_name) {
  if (currency_name === "USD") return "$";
  if (currency_name === "PHP") return "₱";
  return currency_name || "₱";
}

function formatWithCurrency(value, currency_name) {
  if (value === undefined || value === null) return "";
  return getCurrencySymbol(currency_name) + formatToTwoDecimal(value);
}

// `header` is one loaded invoice (items already merged in)
function buildInvoiceBlockRows(header) {
  const items = header.items || [];
  const currency_name = header.currency_name || "PHP";

  const rows = [
    [
      "Transaction Number",
      header.client_transaction_id || "",
      "Invoice Date",
      header.invoice_date ? String(header.invoice_date) : "",
    ],
    [
      "Customer Name",
      getCustomerName(header.customer),
      "Due Date",
      header.due_date ? String(header.due_date) : "",
    ],
    [
      "DR Number",
      header.dr_number || "",
      "Total Amount",
      header.total_amount !== undefined
        ? formatWithCurrency(header.total_amount, currency_name)
        : "",
    ],
    [],
    ["Item List"],
    ITEM_COLUMNS,
  ];

  if (items.length > 0) {
    items.forEach((item) => {
      rows.push([
        item.product_code || "",
        item.product_name || "",
        item.unit_price !== undefined
          ? formatWithCurrency(item.unit_price, currency_name)
          : "",
        item.quantity ?? "",
        item.moisture ?? "",
        item.net_weight ?? "",
        item.discount_item ?? "",
        item.subtotal !== undefined
          ? formatWithCurrency(item.subtotal, currency_name)
          : "",
      ]);
    });
  } else {
    rows.push(["No items"]);
  }

  // Blank spacer rows between one invoice block and the next.
  rows.push([]);
  rows.push([]);

  return rows;
}

// Summary sheet + one sheet per customer
export default function exportInvoiceExcel({ records, meta }) {
  return exportGroupedExcel(records, meta, {
    groupLabel: "Customer",
    countLabel: "No. of Invoices",
    getGroup: (invoice) => ({
      key: invoice.customer?.customer_id,
      name: getCustomerName(invoice.customer),
    }),
    getCurrency: (invoice) => invoice.currency_name || "PHP",
    getAmount: (invoice) => invoice.total_amount,
    buildBlockRows: buildInvoiceBlockRows,
  });
}
